<template>
  <!-- <Modal :show="show" @close-modal="$emit('close-bank-options')"> -->
  <div class="bank-info-country__modal">
    <h2
      class="tw-font-normal tw-text-lg tw-text-secondary tw-mb-3 tw-text-center"
    >
      Select country
    </h2>
    <p class="tw-text-[#4C5B90] tw-text-normal tw-text-center tw-mb-[40px]">
      GetEquity lets you link bank accounts across different regions.
    </p>
    <form @submit.prevent="$emit('bank-method-selected', country)">
      <label
        for="country"
        class="tw-text-[#4C5B90] tw-block tw-text-sm tw-leading-[150%] tw-mb-2"
        >Country</label
      >
      <label for="country" class="tw-block tw-relative">
        <select
          name="country"
          id="country"
          v-model="country"
          ref="select"
          class="tw-h-10 tw-rounded tw-pl-4 tw-w-full bank-info-country__dropdown tw-border-[#D0D5E0] tw-border"
        >
          <option class="" value="" selected disabled>Select Country</option>
          <option
            :value="key"
            v-for="(country, key, index) in countries"
            :key="index"
          >
            {{ country }}
          </option>
        </select>
        <span
          class="tw-absolute tw-right-1 sm:tw-right-4 tw-top-2"
          v-if="!country"
          @mousedown="openDropdown"
        >
          <img
            src="https://res.cloudinary.com/djalafcj9/image/upload/v1653918409/getequityV2/Frame_jhtrqy.svg"
            class=""
            alt="chevron icon"
          />
        </span>
      </label>
      <button
        class="tw-text-sm tw-font-medium tw-bg-primary tw-text-white tw-mt-6 tw-h-12 tw-rounded tw-w-full"
        :disabled="!country"
      >
        Continue
      </button>
    </form>
  </div>
  <!-- </Modal> -->
</template>

<script>
  // import Modal from "@/components/general/Modal"
  export default {
    name: "BankOptions",
    data() {
      return {
        countries: {
          Mono: "Nigeria",
          Stitch: "South Africa",
          Nordigen: "European Countries",
          Plaid: "North America",
          MonoKenya: "Kenya",
          MonoGhana: "Ghana",
          Manual: "Other",
        },
        country: "",
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
    },
    components: {
      // Modal,
    },
    emits: ["close-bank-options", "bank-method-selected"],
    methods: {
      openDropdown(e) {
        const select = this.$refs.select;
        const event = e;
        setTimeout(() => {
          select.dispatchEvent(event);
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  select option:disabled {
    color: #a3a8b3 !important;
  }
  .bank-info {
    &-country__dropdown {
    }
  }
</style>
